export enum CurationStatus {
    COMPLETED = 'completed',
    IN_PROGRESS = 'in-progress',
    PENDING = 'pending',
    FAILED = 'failed',
    QUEUED = 'queued',
    PROCESSING = 'processing',
}

/**
 * Extraction method for data curation jobs
 * - PATIENT: Groups documents by patient, processes all docs for each patient together
 * - DOCUMENT: Processes each document independently
 */
export enum ExtractionMethod {
    PATIENT = 'patient',
    DOCUMENT = 'document',
}

/**
 * Status of individual document processing within a curation job
 */
export enum DocumentProcessingStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

/**
 * Pipeline stages in the data curation process
 */
export enum PipelineStage {
    TAGGER = 'tagger',
    EXTRACTOR = 'extractor',
    CONSOLIDATOR = 'consolidator',
}

/**
 * Error codes for data curation failures
 */
export enum CurationErrorCode {
    DC_SERVICE_UNAVAILABLE = 'DC_SERVICE_UNAVAILABLE',
    SESSION_FAILED = 'SESSION_FAILED',
    DOCUMENT_PROCESSING_FAILED = 'DOCUMENT_PROCESSING_FAILED',
    WEBSOCKET_CONNECTION_FAILED = 'WEBSOCKET_CONNECTION_FAILED',
    TIMEOUT = 'TIMEOUT',
    UNKNOWN = 'UNKNOWN',
}

export enum OntologyFieldDataType {
    TEXT = 'text',
    NUMBER = 'number',
    DATE = 'date',
    BOOLEAN = 'boolean',
    LIST = 'list',
    SELECT = 'select',
}

export enum OntologyFieldCategory {
    DEMOGRAPHICS = 'demographics',
    IDENTIFIER = 'IDENTIFIER',
    CLINICAL = 'clinical',
    LAB = 'lab',
    MEDICATION = 'medication',
    PROCEDURE = 'procedure',
    DIAGNOSIS = 'diagnosis',
    DOCUMENT = 'document',
}
